import { render } from "./AutoriryComponent.vue?vue&type=template&id=336f4980"
import script from "./AutoriryComponent.vue?vue&type=script&lang=js"
export * from "./AutoriryComponent.vue?vue&type=script&lang=js"

import "./AutoriryComponent.vue?vue&type=style&index=0&id=336f4980&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__